import { FC } from 'react'
import { errorBoundaryText, errorBoundaryTitle } from './error-boundary-texts'
import cl from 'classnames'
import './index.scss'

interface ErrorBoundaryViewProps {
    level: string
    className?: string
}

const ErrorBoundaryView: FC<ErrorBoundaryViewProps> = ({
    level,
    className = '',
}) => {
    return (
        <div
            className={cl('error-boundary-main', {
                [`error-boundary-${className}`]: className,
            })}
        >
            <h1>{errorBoundaryTitle(level)}</h1>
            <h3>{errorBoundaryText}</h3>
        </div>
    )
}

export default ErrorBoundaryView
